import { Link } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/footer';
import Seo from '../components/Seo';

const NotFound = () => {
  return (
    <>
      <Seo
        title="Page Not Found | LearnWebAcademy"
        description="The page you are looking for could not be found on LearnWebAcademy."
        canonicalPath="/404/"
        robots="noindex, follow"
      />
      <Header />
      <main className="flex min-h-[70vh] items-center justify-center bg-[#F4F5F7] px-6 py-24 md:px-12">
        <section className="w-full max-w-3xl rounded-[2.5rem] border border-gray-100 bg-white p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] md:p-12">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-[#4CE470]">
            404
          </p>
          <h1 className="mb-6 text-4xl font-extrabold tracking-tight text-[#113A28] md:text-5xl">
            Page not found
          </h1>
          <p className="mx-auto mb-10 max-w-xl text-base leading-relaxed text-gray-600">
            The page may have moved, been removed, or the link may be incorrect.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-xl bg-[#113A28] px-8 py-4 text-sm font-bold text-white transition-colors hover:bg-[#1a573c]"
          >
            Return to Homepage
          </Link>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
